<template>
  <div class="modal-container clearfix">
    <vxe-form
        ref="xForm"
        class="my-form2"
        title-align="right"
        :data="formData">
      <vxe-form-item title="合同类型:" field="contractType" span="24">
        <template>
          <vxe-select v-model="formData.contractType" :options="valueType" placeholder="请选择合同类型" transfer></vxe-select>
        </template>
      </vxe-form-item>
    </vxe-form>
    <div class="footer add-btn-box">
      <Button @click="close" style="border-radius: 5px">取 消</Button>
      <Button type="primary" style="border-radius: 5px" @click="commit">确 定</Button>
    </div>
  </div>
</template>
<script>

import $api from "@/apiProvider";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  data() {
    return {
      formData: {
        contractType: null,
      },
      valueType: [],
      contractId: null
    }
  },
  mounted() {
    this.getDictByCode(41400, 'valueType');
  },
  methods: {
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    init(id, value) {
      this.contractId = id;
      this.formData.contractType = value;
    },
    commit() {
      if (!this.formData.contractType) {
        this.$XModal.alert({
          message: '请选择合同类型',
          status: "error",
        });
      }
      this.updateContractType();
    },
    async updateContractType() {
      showLoading();
      let res = await $api.eleContract.request("updateContractType", {
        id: this.contractId,
        contractType: this.formData.contractType
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("修改成功");
        this.$emit('afterChange')
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.footer {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}
</style>